import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import DashboardLayout from 'src/layouts/dashboard';

// ----------------------------------------------------------------------

// const IndexPage = lazy(() => import('src/layouts/dashboard'));

// Dashboard
const DashboardOverviewPage = lazy(() => import('src/pages/dashboard/dashboard-overview/index'));

// Report
const ReportPage = lazy(() => import('src/pages/dashboard/reports/report'));

// User
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));

// User Contact
const UserContactListPage = lazy(() => import('src/pages/dashboard/user-contact/list'));

// Node
const NodeListPage = lazy(() => import('src/pages/dashboard/node/list'));

// Order
const OrderListPage = lazy(() => import('src/pages/dashboard/order/list'));

// Organize
const OrganizeListPage = lazy(() => import('src/pages/dashboard/organize/list'));

// Article
const ArticleCategoryListPage = lazy(() => import('src/pages/dashboard/article/category/list'));
const ArticleListPage = lazy(() => import('src/pages/dashboard/article/list'));

// Token
const TokenListPage = lazy(() => import('src/pages/dashboard/token/list'));

// Quest
const QuestListPage = lazy(() => import('src/pages/dashboard/quest/list'));

// QuestReward
const QuestRewardListPage = lazy(() => import('src/pages/dashboard/quest-reward/list'));

// Reward
const RewardListPage = lazy(() => import('src/pages/dashboard/reward/list'));

// Redeam
const RedeamListPage = lazy(() => import('src/pages/dashboard/redeam/list'));

// Garbage Collection
const GarbageListPage = lazy(() => import('src/pages/dashboard/garbage/list'));
const GarbageTypeListPage = lazy(() => import('src/pages/dashboard/garbage/garbage-type/list'));
const GarbageCollectionLogListPage = lazy(
  () => import('src/pages/garbage-collection/garbage-collection-log/list')
);
const GarbageCollectionManageTypeListPage = lazy(
  () => import('src/pages/garbage-collection/garbage-collection-manage-type/list')
);
const GarbageCollectionManageByListPage = lazy(
  () => import('src/pages/garbage-collection/garbage-collection-manage-by/list')
);
const GarbageCollectionLocationTypeListPage = lazy(
  () => import('src/pages/garbage-collection/garbage-collection-location-type/list')
);
const GarbageCollectionLocationListPage = lazy(
  () => import('src/pages/garbage-collection/garbage-collection-location/list')
);

// Theme
const ThemeListPage = lazy(() => import('src/sections/theme/view/theme-list-view'));

// Banner
const BannerListPage = lazy(() => import('src/sections/banner/view/banner-list-view'));

// Invitation Code
const InvitationCodePage = lazy(() => import('src/pages/management/Invitation-code/list'));
const InvitationCodeLogPage = lazy(() => import('src/pages/management/Invitation-code-log/list'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const dashboardRoutes = [
  {
    path: 'dashboard',
    children: [
      {
        path: 'dashboard-overview',
        element: <AuthGuard>{layoutContent}</AuthGuard>,
        children: [{ element: <DashboardOverviewPage />, index: true }],
      },
      {
        path: 'report',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [{ element: <ReportPage />, index: true }],
      },
      {
        path: 'user',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <UserListPage />, index: true },
          { path: 'list', element: <UserListPage /> },
        ],
      },
      {
        path: 'user-contact',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <UserContactListPage />, index: true },
          { path: 'list', element: <UserContactListPage /> },
        ],
      },
      {
        path: 'article',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <ArticleListPage />, index: true },
          { path: 'list', element: <ArticleListPage /> },
          { path: 'category/list', element: <ArticleCategoryListPage /> },
        ],
      },
      {
        path: 'quest',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <QuestListPage />, index: true },
          { path: 'list', element: <QuestListPage /> },
        ],
      },
      {
        path: 'quest-reward',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <QuestRewardListPage />, index: true },
          { path: 'list', element: <QuestRewardListPage /> },
        ],
      },
      {
        path: 'reward',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <RewardListPage />, index: true },
          { path: 'list', element: <RewardListPage /> },
        ],
      },
      {
        path: 'redeam',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <RedeamListPage />, index: true },
          { path: 'list', element: <RedeamListPage /> },
        ],
      },
      {
        path: 'garbage',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <GarbageListPage />, index: true },
          { path: 'list', element: <GarbageListPage /> },
          { path: 'garbage-type/list', element: <GarbageTypeListPage /> },
        ],
      },
      {
        path: 'node',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <NodeListPage />, index: true },
          { path: 'list', element: <NodeListPage /> },
        ],
      },
      {
        path: 'order',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <OrderListPage />, index: true },
          { path: 'list', element: <OrderListPage /> },
        ],
      },
      {
        path: 'organize',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <OrganizeListPage />, index: true },
          { path: 'list', element: <OrganizeListPage /> },
        ],
      },
      {
        path: 'token',
        element: (
          <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>
        ),
        children: [
          { element: <TokenListPage />, index: true },

          { path: 'list', element: <TokenListPage /> },
        ],
      },
    ],
  },
  {
    path: 'garbage-collection',
    element: <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>,
    children: [
      {
        path: 'garbage-collection-log',
        children: [
          { element: <GarbageCollectionLogListPage />, index: true },
          { path: 'list', element: <GarbageCollectionLogListPage /> },
        ],
      },
      {
        path: 'garbage-collection-manage-type',
        children: [
          { element: <GarbageCollectionManageTypeListPage />, index: true },
          { path: 'list', element: <GarbageCollectionManageTypeListPage /> },
        ],
      },
      {
        path: 'garbage-collection-manage-by',
        children: [
          { element: <GarbageCollectionManageByListPage />, index: true },
          { path: 'list', element: <GarbageCollectionManageByListPage /> },
        ],
      },
      {
        path: 'garbage-collection-location-type',
        children: [
          { element: <GarbageCollectionLocationTypeListPage />, index: true },
          { path: 'list', element: <GarbageCollectionLocationTypeListPage /> },
        ],
      },
      {
        path: 'garbage-collection-location',
        children: [
          { element: <GarbageCollectionLocationListPage />, index: true },
          { path: 'list', element: <GarbageCollectionLocationListPage /> },
        ],
      },
    ],
  },
  {
    path: 'management',
    element: <AuthGuard allowedRoles={['MANAGER', 'ADMIN', 'SYSTEM']}>{layoutContent}</AuthGuard>,
    children: [
      {
        path: 'theme',
        children: [
          { element: <ThemeListPage />, index: true },
          { path: 'list', element: <ThemeListPage /> },
        ],
      },
      {
        path: 'banner',
        children: [
          { element: <BannerListPage />, index: true },
          { path: 'list', element: <BannerListPage /> },
        ],
      },
      {
        path: 'invitation-code',
        children: [
          { element: <InvitationCodePage />, index: true },
          { path: 'list', element: <InvitationCodePage /> },
        ],
      },
      {
        path: 'invitation-code-log',
        children: [
          { element: <InvitationCodeLogPage />, index: true },
          { path: 'list', element: <InvitationCodeLogPage /> },
        ],
      },
    ],
  },
];
